<template>
  <div class="map-pointMonitor">
    <div id="my-map"></div>
    <el-dialog
      title="2026年1月14日余杭水质断面无人机巡检测试报告"
      :visible.sync="infoWindowVisible"
      width="50%"
    >
      <div class="content">
        <el-row v-for="item in reportList.report" :key="item.id">
          <el-col :span="3">
            <div class="label">{{ item.label }}:</div>
          </el-col>
          <el-col :span="21">
            <div class="details" v-if="!Array.isArray(item.details)">
              {{ item.details }}
            </div>
            <div class="details" v-else>
              <div v-for="detail in item.details" :key="detail.unit">
                <div>{{ detail.unit }}: {{ detail.name }}</div>
              </div>
            </div>
            <!-- <div v-else>
              <div v-for="info in item.test_content" :key="info.id">
                <div class="info-label">{{ info.name }}:</div>
              </div>
            </div> -->
          </el-col>
        </el-row>
        <div class="test-content">
          <div class="label">测试内容:</div>
          <div class="info">
            <div class="label">1、无人机高光谱水质断面检测</div>
            <div class="describe">
              飞手驾驶车辆带着无人机，到检测点位旁，通过标定布对高光谱摄像机进行标定，无人机放置发电车车顶，无人机起飞执行航线任务，无人机到达作业点时拍摄照片，任务完毕后无人机返回，降落到车顶。
              <div>
                飞行相关参数为：航线高度260m、航速7.5m/s，飞行距离约500m，飞行时长约5分钟。
              </div>
            </div>
            <div class="title">无人机高光谱检测结果</div>
            <figure
              class="image_list"
              v-for="info in reportList.imgList"
              :key="info.id"
            >
              <el-image
                style="width: 100%"
                :src="info.src"
                :preview-src-list="src_list"
              >
              </el-image>
              <figcaption class="description">
                {{ info.caption }}
              </figcaption>
            </figure>
            <div class="label">2、车载多光谱设备检测</div>
            <div class="describe">
              （1）提取水样
              <div>
                现场采集水样两份，一份供多光谱设备现场检测，一份送实验室化学法分析。
              </div>
            </div>
            <figure
              class="image_list"
              v-for="img in reportList.water_imgList"
              :key="img.caption"
            >
              <el-image
                style="width: 100%"
                :src="img.src"
                :preview-src-list="water_src_list"
              >
              </el-image>
              <figcaption class="description">
                {{ img.caption }}
              </figcaption>
            </figure>
            <div class="describe">
              （2）车载多光谱设备检测
              <div>
                发电车给多光谱设备供电，多光谱设备进行抽取水样检测。
              </div>
              <el-image
                style="width: 100%"
                :src="vehicleImg"
                :preview-src-list="[vehicleImg]"
              >
              </el-image>
            </div>
            <div class="describe">
              （3）显示检测结果
              <div>
                检测5分钟后，显示检测结果数据。
              </div>
              <div class="table-row">
                <span class="label">检测结果:</span>
                <el-table :data="multispectral_tableData">
                  <el-table-column prop="type"></el-table-column>
                  <el-table-column
                    label="CODmn（高锰酸盐）"
                    prop="CODmn（高锰酸盐）"
                    min-width="120"
                  ></el-table-column>
                  <el-table-column
                    label="TP（总磷）"
                    prop="TP（总磷）"
                  ></el-table-column>
                  <el-table-column
                    label="TN（总氮）"
                    prop="TN（总氮）"
                    class-name="warn-column"
                  ></el-table-column>
                  <el-table-column
                    label="NH3N（氨氮）"
                    prop="NH3N（氨氮）"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
            <div class="label">3、实验室化学法水质分析</div>
            <div class="describe">
              <div class="table-row">
                <div class="label">检测结果:</div>
                <el-table :data="chemical_tableData">
                  <el-table-column prop="type"></el-table-column>
                  <el-table-column
                    label="CODmn（高锰酸盐）"
                    prop="CODmn（高锰酸盐）"
                    min-width="120"
                  ></el-table-column>
                  <el-table-column
                    label="TP（总磷）"
                    prop="TP（总磷）"
                  ></el-table-column>
                  <el-table-column
                    label="TN（总氮）"
                    prop="TN（总氮）"
                    class-name="warn-column"
                  ></el-table-column>
                  <el-table-column
                    label="NH3N（氨氮）"
                    prop="NH3N（氨氮）"
                  ></el-table-column>
                </el-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
let map = null;
const pointList = [
  {
    id: 1,
    name: "仁和水厂",
    coordinates: [120.06669403, 30.48615329],
  },
  {
    id: 2,
    name: "奉口",
    coordinates: [120.06872177, 30.44549192],
  },
  {
    id: 3,
    name: "武林头",
    coordinates: [120.14847056, 30.46968895],
  },
  {
    id: 4,
    name: "五福桥",
    coordinates: [120.14348164, 30.46692286],
  },
  {
    id: 5,
    name: "塘栖大桥",
    coordinates: [120.15010536, 30.46298107],
  },
  {
    id: 6,
    name: "馒头山水库",
    coordinates: [119.70949888, 30.43262508],
  },
  {
    id: 7,
    name: "木鱼岭",
    coordinates: [119.82191563, 30.43411905],
  },
  {
    id: 8,
    name: "四岭水库",
    coordinates: [119.78800178, 30.41792465],
  },
  {
    id: 9,
    name: "瓶窑大桥",
    coordinates: [119.97066021, 30.3956223],
  },
  {
    id: 10,
    name: "瓶窑水厂",
    coordinates: [119.96793509, 30.37880832],
  },
  {
    id: 11,
    name: "张堰大桥",
    coordinates: [119.9411881, 30.37088159],
  },
  {
    id: 12,
    name: "落塘埠",
    coordinates: [119.94472727, 30.34653621],
  },
  {
    id: 13,
    name: "义桥",
    coordinates: [120.12803077, 30.37828074],
  },
  {
    id: 14,
    name: "石祥路运河桥",
    coordinates: [120.13747752, 30.33433115],
  },
  {
    id: 15,
    name: "径山",
    coordinates: [119.81146574, 30.32641586],
  },
  {
    id: 16,
    name: "汪家埠",
    coordinates: [119.8720622, 30.25500813],
  },
  {
    id: 17,
    name: "仓前桥",
    coordinates: [119.96179417, 30.27523926],
  },
  {
    id: 18,
    name: "长桥",
    coordinates: [120.0367713, 30.30263141],
  },
  {
    id: 19,
    name: "师母桥泵站",
    coordinates: [120.0501354, 30.27702867],
  },
];
import AMap from "AMap";
export default {
  name: "PointMonitor",
  data() {
    return {
      infoWindow: null,
      infoWindowVisible: false,
      reportList: {
        id: 1,
        pointId: 18,
        date: "2026-01-14",
        report: [
          {
            id: 1,
            label: "测试设备",
            details:
              "大疆M350无人机、电池、高光谱摄像机、标定布、充电箱一台、1.0发电车一台、车载多光谱设备",
          },
          // {
          //   id: 2,
          //   label: "锦辉",
          //   details: "1.0发电车一台",
          // },
          // {
          //   id: 3,
          //   label: "希玛诺",
          //   details: "车载多光谱设备",
          // },
          {
            id: 4,
            label: "测试日期",
            details: "2026年1月14日",
          },
          // {
          //   id: 5,
          //   label: "测试人员",
          //   details: [
          //     {
          //       unit: "杭州中丞",
          //       name: "飞手",
          //     },
          //     {
          //       unit: "锦辉",
          //       name: "许光智、邢天宇",
          //     },
          //     {
          //       unit: "希玛诺",
          //       name: "曾勇、技术人员",
          //     },
          //   ],
          // },
          {
            id: 6,
            label: "测试地点",
            details: [
              {
                unit: "地点",
                name: "阿里巴巴渣土码头",
              },
              { unit: "检测水质断面", name: "余杭塘河" },
            ],
          },
          // {
          //   id: 7,
          //   label: "测试内容",
          //   test_content: [
          //     {
          //       id: 1,
          //       name: "无人机多光谱检测结果",
          //       imgList: [
          //         {
          //           src: require("@/assets/images/uav/1/TP.png"),
          //           caption: "图1-1 高锰酸钾III类",
          //         },
          //         {
          //           src: require("@/assets/images/uav/1/TP.png"),
          //           caption: "图1-2 氨氮IV类",
          //         },
          //         {
          //           src: require("@/assets/images/uav/1/TP.png"),
          //           caption: "图1-3 总磷III类",
          //         },
          //         {
          //           src: require("@/assets/images/uav/1/TP.png"),
          //           caption: "图1-4 浑浊度",
          //         },
          //       ],
          //     },
          //     {
          //       id: 2,
          //       name: "车载多光谱设备水样检测",
          //       result: [
          //         {
          //           title: "（1）提取水样",
          //           imgList: [
          //             {
          //               src: require("@/assets/images/uav/1/img1.jpg"),
          //               caption: "图1-1 提取水样图片",
          //             },
          //             {
          //               src: require("@/assets/images/uav/1/img2.jpg"),
          //               caption: "图1-2 提取水样图片",
          //             },
          //           ],
          //         },
          //         {
          //           title: "（2）车载多光谱设备检测",
          //           data: {
          //             chemical_tableData: [
          //               { label: "CODmn（高锰酸盐）", value: "3.83" },
          //               { label: "TN（总氮）", value: "3.64" },
          //               { label: "TP（总磷）", value: "0.162" },
          //               { label: "NH3N（氨氮）", value: "1.51" },
          //             ],
          //             name: "实验室化学法水质分析",
          //             multispectral_tableData: [
          //               { label: "CODmn（高锰酸盐）", value: "3.65" },
          //               { label: "TN（总氮）(COD)", value: "3.27" },
          //               { label: "TP（总磷）", value: "0.177" },
          //               { label: "NH3N（氨氮)", value: "1.65" },
          //             ],
          //           },
          //         },
          //       ],
          //     },
          //   ],
          // },
        ],
        imgList: [
          {
            id: 1,
            src: require("@/assets/images/uav/1/CODmn.png"),
            caption: "图1-1 高锰酸钾III类",
          },
          {
            id: 2,
            src: require("@/assets/images/uav/1/NH3N.png"),
            caption: "图1-2 氨氮IV类",
          },
          {
            id: 3,
            src: require("@/assets/images/uav/1/TP.png"),
            caption: "图1-3 总磷III类",
          },
          {
            id: 4,
            src: require("@/assets/images/uav/1/TU.png"),
            caption: "图1-4 浑浊度",
          },
        ],
        water_imgList: [
          {
            src: require("@/assets/images/uav/1/img1.jpg"),
            caption: "图1-1 提取水样图片",
          },
          {
            src: require("@/assets/images/uav/1/img2.jpg"),
            caption: "图1-2 提取水样图片",
          },
        ],
      },
      vehicleImg: require("@/assets/images/uav/1/vehicle_img.png"),
      multispectral_tableData: [
        {
          type: "车载多光谱设备",
          "CODmn（高锰酸盐）": "3.65",
          "TP（总磷）": "0.177",
          "TN（总氮）": "3.27",
          "NH3N（氨氮）": "1.65",
        },
        {
          type: "分类",
          "CODmn（高锰酸盐）": "II类",
          "TP（总磷）": "III类",
          "TN（总氮）": "劣V类",
          "NH3N（氨氮）": "V类",
        },
      ],
      chemical_tableData: [
        {
          type: "化学实验法",
          "CODmn（高锰酸盐）": "3.83",
          "TP（总磷）": "0.162",
          "TN（总氮）": "3.64",
          "NH3N（氨氮）": "1.51",
        },
        {
          type: "分类",
          "CODmn（高锰酸盐）": "II类",
          "TP（总磷）": "III类",
          "TN（总氮）": "劣V类",
          "NH3N（氨氮）": "V类",
        },
      ],
    };
  },
  computed: {
    // 预览图片列表
    src_list() {
      return this.reportList.imgList.map((item) => item.src);
    },
    water_src_list() {
      return this.reportList.water_imgList.map((item) => item.src);
    },
    // tableData() {
    //   let tableData = [];
    //   this.chemical_tableData.forEach((item) => {
    //     tableData[0][item.label] = item.value;
    //     // tableData[1][item.label] = item.level;
    //   });
    //   console.log(tableData);

    //   return tableData;
    // },
    m_tableData() {
      let m_tableData = [{}];
      this.multispectral_tableData.forEach((item) => {
        m_tableData[0][item.label] = item.value;
      });
      return m_tableData;
    },
  },
  mounted() {
    this.initMap();
    this.addPoints();
  },
  methods: {
    addPoints() {
      let marker = null;
      let markerList = [];
      pointList.forEach((item) => {
        marker = new AMap.Marker({
          position: item.coordinates,
          title: item.name,
        });
        marker.setLabel({
          direction: "center",
          offset: new AMap.Pixel(0, -28), //设置文本标注偏移量
          content: item.name
            ? "<span class='marker-label'>" + item.name + "</span>"
            : "", //设置文本标注内容
        });
        markerList.push(marker);
        // 添加长桥信息窗体
        if (item.id === 18) {
          marker.on("click", () => {
            console.log("onclick marker");
            this.infoWindowVisible = true;
          });
        }
      });

      map.add(markerList);
      this.$nextTick(() => {
        map.setFitView();
      });
    },
    initMap() {
      map = new AMap.Map("my-map", {
        resizeEnable: true,
        zoom: 12,
        zooms: [3, 20],
        expandZoomRange: true,
        layers: [
          new AMap.TileLayer.Satellite(),
          // 路网
          //   new AMap.TileLayer.RoadNet(),
        ],
      });
      // scale 比例尺
      AMap.plugin(["AMap.Scale"], () => {
        let scale = new AMap.Scale({
          visible: true,
        });
        map.addControl(scale);
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.map-pointMonitor {
  width: 100%;
  height: 100%;
  #my-map {
    width: 100%;
    height: 100%;
    min-height: 720px;
  }
  /deep/ .el-dialog__body {
    max-height: 650px;
    overflow: auto;
    .content {
      line-height: 30px;
      .label {
        font-weight: bold;
        margin-bottom: 10px;
      }
      .details {
        color: #666;
        margin-bottom: 10px;
      }
      .test-content {
        .info {
          .label {
            line-height: 20px;
            font-weight: bold;
            margin-top: 10px;
          }
          .describe {
            text-indent: 2em;
            .table-row {
              display: flex;
              flex-direction: column;
              align-items: start;
              .label {
                font-weight: 400;
              }
              /deep/ .el-table--border::after {
                background-color: #ccc;
              }
              /deep/ .el-table {
                width: 490px;
                flex: none;
                border-top: 1px solid #ccc;
                border-left: 1px solid #ccc;
                margin-left: 2em;
                td:first-child .cell,
                th:first-child .cell {
                  padding-left: 0;
                  text-align: center;
                }
                .cell {
                  white-space: nowrap;
                  overflow: visible;
                  text-align: center;
                }
                th,
                td {
                  background: #fff;
                  color: #000;
                  font-size: 12px;
                  font-weight: 400;
                  padding: 0;
                  border-bottom: 1px solid #ccc;
                  border-right: 1px solid #ccc;
                }
                .warn-column {
                  background: #e54c5e;
                }
              }
            }
          }
          .image_list {
            /deep/ .el-image {
              display: block;
            }
            .description {
              text-align: center;
            }
          }
        }
      }
    }
  }

  /deep/ .amap-marker-label {
    border: none;
    padding: 2px;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.3);
  }
  /deep/ .amap-scalecontrol {
    margin-left: 10px;
    b .amap-scale-text {
      color: #fff !important;
    }
  }
}
</style>
